import React from 'react'
import classNames from 'classnames'
import { Heading, Paragraph } from '@scentregroup/ui'

import { FeaturedLink, ImageType } from '../../../../types/featured-link'
import { Link as LinkType } from '../../../../types/link'
import ResponsiveImage from '../../responsive-image'
import style from './index.scss'

export const Slide: React.FC<{
  Link: LinkType
  featuredLink: FeaturedLink
}> = ({ Link, featuredLink }) => {
  const isSquare = featuredLink.imageType === ImageType.square
  return (
    <Link
      to={featuredLink.url}
      className={classNames(style.FeaturedLink, { [style.square]: isSquare })}
    >
      <ResponsiveImage
        desktopImageUrl={featuredLink.imageUrl}
        mobileImageUrl={featuredLink.imageUrl}
        desktopRatio={isSquare ? 'square' : 'feature'}
        alt={featuredLink.title}
        className={style.image}
      />
      <div className={style.shroud} aria-hidden="true" />
      <div className={style.info}>
        <Heading type="medium">{featuredLink.title}</Heading>
        <Paragraph className={style.shortDescription}>
          {featuredLink.shortDescription}
        </Paragraph>
        <Paragraph className={style.link}>Find out more</Paragraph>
      </div>
    </Link>
  )
}
